import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as CryptoJS from "crypto-js";

@Injectable({
   providedIn: 'root'
})
export class MD5UtilService {

   Key_IV = "79994A6EF73DA76C";
   PASSWORD = "EF737CC29DAE7C80644A5B01544CBA61";
   SALT = "12345";
   constructor(private http: HttpClient) { }

   getMd5Checksum(string) {
      return CryptoJS.MD5(string);
   }
 
 
   getAESEncrption(string){
      return CryptoJS.AES.encrypt (string,'yourMudra126SecretK756tryKey').toString();
   }
   Decrypt(string){
      return CryptoJS.AES.decrypt (string,'yourMudra126SecretK756tryKey').toString(CryptoJS.enc.Utf8);
       
  
   }
   //..................RSA ENCRYPTION.............................................
}